module.exports = __webpack_public_path__ + "static/media/bolso (42).b3871c00.jpg";